module.exports = __webpack_public_path__ + "img/DSC_0004.e942231d.jpg";